// @ts-check
import ChooseEntityNotice from './ChooseEntityNotice';

export default ChooseEntityNotice;
